import DetailedListTopicsContainer from "@features/session/containers/DetailedListTopicsContainer";

const ReportDetailedListMasteryRoute = () => {
	return <DetailedListTopicsContainer />;
};

export default ReportDetailedListMasteryRoute;
